/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_Verified_NfpInputs */

const en_status_verified_nfp = /** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verified Non-Profit`)
};

const es_status_verified_nfp = /** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ONG Verificada`)
};

const fr_status_verified_nfp = /** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Association Vérifiée`)
};

const de_status_verified_nfp = /** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifizierte NGO`)
};

const id_status_verified_nfp = /** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non-Profit Terverifikasi`)
};

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const ja_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const zh_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const ar_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const it_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const ru_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const pt_status_verified_nfp = en_status_verified_nfp;

/** @type {(inputs: Status_Verified_NfpInputs) => LocalizedString} */
const ko_status_verified_nfp = en_status_verified_nfp;

/**
* | output |
* | --- |
* | "Verified Non-Profit" |
*
* @param {Status_Verified_NfpInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const status_verified_nfp = /** @type {((inputs?: Status_Verified_NfpInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_Verified_NfpInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_verified_nfp(inputs)
	if (locale === "es") return es_status_verified_nfp(inputs)
	if (locale === "fr") return fr_status_verified_nfp(inputs)
	if (locale === "de") return de_status_verified_nfp(inputs)
	if (locale === "ja") return ja_status_verified_nfp(inputs)
	if (locale === "zh") return zh_status_verified_nfp(inputs)
	if (locale === "ar") return ar_status_verified_nfp(inputs)
	if (locale === "id") return id_status_verified_nfp(inputs)
	if (locale === "it") return it_status_verified_nfp(inputs)
	if (locale === "ru") return ru_status_verified_nfp(inputs)
	if (locale === "pt") return pt_status_verified_nfp(inputs)
	return ko_status_verified_nfp(inputs)
});